import axios, { AxiosError } from "axios";
import { ZodError } from "zod";
import { static_errors } from "./constants";
import { ApiErrorBodySchema, RequestError } from "./schema";

export const parseRequestError = (
	error: unknown | AxiosError | ZodError | Error,
): RequestError => {
	if (error instanceof ZodError) {
		if (process.env.NODE_ENV === "development") {
			console.error(`🛑🛑🛑 Zod error detected: ${error} 🛑🛑🛑`);
		}

		return {
			code: -2,
			message: static_errors.vital_parsing_error,
			details: null,
		};
	}

	if (axios.isAxiosError(error)) {
		console.log(error);

		const response = error.response;
		if (response) {
			const errorData = response.data?.error;
			if (instanceOfError(errorData)) {
				return errorData;
			}
			if (typeof errorData === "string") {
				return {
					code: -1,
					message: errorData,
					details: null,
				};
			}
			if (typeof errorData === "object" && errorData !== null) {
				return {
					code: -1,
					message: errorData.message,
					details: null,
				};
			}
			if (response?.data?.message) {
				return {
					code: -1,
					message: response.data.message,
					details: null,
				};
			}
		}
		return {
			code: -1,
			message: static_errors.unexpected_contact_support,
			details: null,
		};
	}
	return {
		code: -1,
		message: static_errors.unexpected_contact_support,
		details: null,
	};
};

export const instanceOfError = (object: unknown): object is RequestError => {
	const result = ApiErrorBodySchema.safeParse(object);
	return result.success;
};
